import slugify from 'slugify'
import {
  OPPORTUNITIES_INFO,
  OPPORTUNITIES_SORT,
} from '@/modern/utils/constants'

export const createOpportunityId = opportunity =>
  opportunity
    .toLowerCase()
    .split(' ')
    .map((word, index) =>
      index === 0 ? word : `${word[0].toUpperCase()}${word.substring(1)}`
    )
    .join('')

export const createOpportunity = opportunity => {
  const id = createOpportunityId(opportunity.name)
  const displayName =
    (OPPORTUNITIES_INFO[id] && OPPORTUNITIES_INFO[id].displayName) ||
    opportunity.name
  const showBadge =
    (OPPORTUNITIES_INFO[id] && OPPORTUNITIES_INFO[id].showBadge) ||
    OPPORTUNITIES_INFO.default.showBadge

  return {
    ...opportunity,
    selected: !!opportunity.selected,
    id,
    displayName,
    showBadge,
    badge: slugify(opportunity.name, { lower: true }),
  }
}

export const sortOpportunities = defaultSortFunc => (a, b) => {
  const foundA = OPPORTUNITIES_SORT.indexOf(a.id)
  const foundB = OPPORTUNITIES_SORT.indexOf(b.id)

  let value = 0

  if (foundA >= 0 && foundB >= 0) value = foundA < foundB ? -1 : 1

  if (foundA >= 0 && !(foundB >= 0)) value = -1

  if (!(foundA >= 0) && foundB >= 0) value = 1

  if (!(foundA >= 0) && !(foundB >= 0) && typeof defaultSortFunc === 'function')
    value = defaultSortFunc(a, b)

  return value
}
